import React from 'react';
import Tooltip from 'react-tooltip-component';
import HeartHealthy from '../../../../../public/images/icons/icon-heart-healthy.svg';
import Gluten from '../../../../../public/images/icons/icon-gluten.svg';
import Dairy from '../../../../../public/images/icons/icon-dairy.svg';
import { injectIntl } from 'react-intl';
import defaultMsg from '../../../../../translations/lang/en-US.json';

class NutritionalIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: this.props.status,
      iconCategory: this.props.type,
      type: this.props.type,
    };
  }

  getType = type => {
    switch (type.toLowerCase()) {
      case 'heart':
        return HeartHealthy;
      case 'gluten':
        return Gluten;
      case 'dairy':
        return Dairy;
      default:
        return false;
    }
  };

  getTitle = type => {
    switch (type.toLowerCase()) {
      case 'heart':
        return this.props.intl.formatMessage({ id: 'heartHealthy', defaultMessage: defaultMsg.heartHealthy });
      case 'gluten':
        return this.props.intl.formatMessage({ id: 'containsGluten', defaultMessage: defaultMsg.containsGluten });
      case 'dairy':
        return this.props.intl.formatMessage({ id: 'containsDairy', defaultMessage: defaultMsg.containsDairy });
      default:
        return false;
    }
  };

  render() {
    const iconSvg = this.getType(this.state.type);
    const iconTitle = this.getTitle(this.state.type);
    return Number(this.state.status) === 1 && iconSvg ? (
      <Tooltip
        title={iconTitle}
        position="top"
      >
        <img src={iconSvg} className="nutritional-icon" alt={this.state.type} />
      </Tooltip>
    ) : null;
  }
}

export default (injectIntl(NutritionalIcon));


// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/NutritionalIcon.jsx